// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3hqN5","requiredAsterisk":"Info_requiredAsterisk__19h2O"};